import { useEffect, useState } from 'react';

const useWindowResize = (
  options = {
    debounceTime: 200,
    cleanup: true,
    initialResizeState: false,
  },
) => {
  const { debounceTime = 200, cleanup = true, initialResizeState = false } = options;
  const [isResized, setIsResized] = useState(initialResizeState);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const handleResize = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(() => {
        setIsResized(true);
      }, debounceTime);
    };

    const resetResized = () => {
      setIsResized(initialResizeState);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      if (cleanup) {
        resetResized();
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [debounceTime, cleanup, initialResizeState]);

  return isResized;
};

export default useWindowResize;
